import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';

class Form extends React.Component {
	apiURL = process.env.REACT_APP_API_URL;

	constructor() {
		super();

		this.state = {
			name: '',
			data: '',
			random: false,
			random_answers: false,
			correct: 'Good work',
			incorrect: 'That\'s not correct',
			bb_randomise_answers: false,
			bb_number_type: "none",
			bb_orientation_type: "vertical",
			all_questions: true,
			bb_default_point_value: 1
		};

		this.form = null;

		this.handleChangeName = this.handleChangeName.bind(this);
		this.handleChangeData = this.handleChangeData.bind(this);
		this.handleChangeRandom = this.handleChangeRandom.bind(this);
		this.handleChangeRandomAnswers = this.handleChangeRandomAnswers.bind(this);
		this.handleChangeCorrect = this.handleChangeCorrect.bind(this);
		this.handleChangeIncorrect = this.handleChangeIncorrect.bind(this);
		this.handleBbRandomiseAnswers = this.handleBbRandomiseAnswers.bind(this);
		this.handleBbNumberType = this.handleBbNumberType.bind(this);
		this.handleBbOrientationType = this.handleBbOrientationType.bind(this);
		this.handleBbDefaultPointValue = this.handleBbDefaultPointValue.bind(this);

	}

	//  change events
	handleChangeName = (event) => this.setState({ name: event.target.value });
	handleChangeData = (event) => this.setState({ data: event.target.value });
	handleChangeRandom = (event) => this.setState({ random: event.target.checked });
	handleChangeRandomAnswers = (event) => this.setState({ random_answers: event.target.checked });
	handleChangeCorrect = (event) => this.setState({ correct: event.target.value });
	handleChangeIncorrect = (event) => this.setState({ incorrect: event.target.value });
	handleBbRandomiseAnswers = (event) => this.setState({ bb_randomise_answers: event.target.value });
	handleBbNumberType = (event) => this.setState({ bb_number_type: event.target.value });
	handleBbOrientationType = (event) => this.setState({ bb_orientation_type: event.target.value });
	handleBbDefaultPointValue = (event) => this.setState({ bb_default_point_value: event.target.value });

	submit = () => {
		confirmAlert({
			title: 'Confirm',
			message: 'This type of generation will only process MCQ questions, any other type of questions will not be processed and placed in the zip file.',
			buttons: [
				{
					label: 'Continue',
					onClick: () => this.form.submit()
				},
				{
					label: 'Cancel'
				}
			]
		});
	};

	render() {
		return (
			<div className="form-container">
				<h5 className="documentation-header">Generator</h5>
				<form action={this.apiURL + "quiz-transform"} ref={(ref) => this.form = ref} method="post">
					<input type="hidden" name="all_questions" value={this.state.all_questions} />
					<input type="hidden" name="bb_number_type" value={this.state.bb_number_type} />
					<input type="hidden" name="bb_default_point_value" value={this.state.bb_default_point_value} />
					<div className="form-group">
						<label htmlFor="name">Question Pool Name<span className="required">*</span>:</label>
						<input type="text" name="name" value={this.state.name} onChange={this.handleChangeName} className="form-control" id="name" aria-describedby="nameHelp" placeholder="Enter name of question pool" />
						<small id="nameHelp" className="form-text text-muted">This name identifies the set of questions in blackboard</small>
					</div>
					<div className="form-group">
						<label htmlFor="data">Questions Data<span className="required">*</span>:</label>
						<textarea rows="15" id="data" aria-describedby="dataHelp" value={this.state.data} onChange={this.handleChangeData} className="form-control" type="text" name="data"></textarea>
						<small id="dataHelp" className="form-text text-muted">Question data - please ensure correctly formatted per rules on left</small>
					</div>
					<div className="btn-group" role="group">
						<button type="button" onClick={() => this.setState({ all_questions: true })} disabled={this.state.all_questions} className="btn btn-secondary">All Question Types</button>
						<button type="button" onClick={() => this.setState({ all_questions: false })} disabled={!this.state.all_questions} className="btn btn-secondary">Multiple Choice Only</button>
					</div>
					{
						!this.state.all_questions &&
						<div className="mt-2">
							<div className="alert alert-danger" role="alert">
								<b>Warning:</b> Only use this mode if your question pool will <b>ONLY</b> consist of multiple choice questions. Otherwise select "All Question Types".<br /><br />
								Any other type of question will not be processed in this mode.
							</div>
							<div className="alert alert-success" role="alert">
								In this mode, all question names will automatically be populated and padded. (E.g. Q001)
							</div>
							<div className="form-group">
								<label htmlFor="data">Answer Number Type<span className="required">*</span>:</label>
								<select className="form-control" onChange={(event) => this.setState({ bb_number_type: event.target.value })} value={this.state.bb_number_type}>
									<option value="none">None (default)</option>
									<option value="arabic">Arabic (1, 2)</option>
									<option value="roman">Roman (I, II)</option>
									<option value="letter_lower">Lowercase Letters (a, b)</option>
									<option value="letter_upper">Uppercase Letters (A, B)</option>
								</select>
								<small id="dataHelp" className="form-text text-muted">Answers will be prepended with a, i, 1</small>
							</div>
							<div className="form-group">
								<label htmlFor="defaultPointValue">Default Point Value<span className="required">*</span>:</label>
								<input type="number" step="0.1" min="1" required name="defaultPointValue" value={this.state.bb_default_point_value} onChange={this.handleBbDefaultPointValue} className="form-control" id="defaultPointValue" aria-describedby="defaultPointValueHelp" placeholder="Default point value of each question" />
								<small id="defaultPointValueHelp" className="form-text text-muted">The default point value or weighting of each question</small>
							</div>
							<div className="form-check">
								<input type="checkbox" id="bb_random_answers" className="form-check-input" defaultChecked={this.state.bb_randomise_answers} onChange={this.handleBbRandomiseAnswers} name="bb_random_answers" />
								<label className="form-check-label" htmlFor="bb_random_answers">Randomise multiple choice answers</label>
							</div>
						</div>
					}
					{
						this.state.all_questions &&
						<input type="submit" disabled={!this.state.name.length || !this.state.data.length} className="btn btn-success btn-generate" value="Generate Question Pool" />
					}
					{
						!this.state.all_questions &&
						<button type="button" onClick={this.submit} disabled={!this.state.name.length || !this.state.bb_default_point_value || !this.state.data.length} className="btn btn-success btn-generate">Generate MCQ Only Question Pool</button>
					}
				</form>
			</div>
		)
	}
}

export default Form;
